import { render } from "./signin-confirmation.vue?vue&type=template&id=01ad9882&scoped=true"
import script from "./signin-confirmation.vue?vue&type=script&lang=js"
export * from "./signin-confirmation.vue?vue&type=script&lang=js"

import "./signin-confirmation.vue?vue&type=style&index=0&id=01ad9882&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ad9882"]])

export default __exports__